import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-empty-buildings-popup',
  templateUrl: './empty-buildings-popup.component.html',
  styleUrls: ['./empty-buildings-popup.component.scss'],
})
export class EmptyBuildingsPopupComponent {
  @Input() hideClose = false;
  @Output() closeEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(public router: Router) {}

  public goToMap(): void {
    this.router.navigate(['/energiekarte'], {
      queryParams: {
        action: 'openBuildingMenu',
        returnroute: '/effizienzanalyse',
      },
    });
  }

  public closeModal(): void {
    this.closeEvent.emit();
  }
}
